import { Component, inject } from "@angular/core";
import { APP_CONFIG_TOKEN } from "@kno2/core/config";

@Component({
    selector: "kno2-unsupported-browser",
    template: `
        <div style="height: 100vh; background-color: #fff; padding-top: 100px">
            <h1 class="text-center">Unsupported Browser.</h1>
            <h2 class="text-center">We recommend the latest version of Chrome, Firefox or Microsoft Edge to use {{ brandDisplayName }}.</h2>
            <div class="text-center">
                <a
                    href="http://www.google.com/chrome/intl/en/dl/download.html"
                    target="_blank"
                    rel="noopener noreferrer">
                    <img src="/images/chrome_128x128.png" />
                </a>
                <a
                    href="https://www.mozilla.org/en-US/firefox/new/"
                    target="_blank"
                    rel="noopener noreferrer">
                    <img src="/images/firefox_128x128.png" />
                </a>
                <a
                    href="https://www.microsoft.com/en-us/edge/download"
                    target="_blank"
                    rel="noopener noreferrer">
                    <img src="/images/microsoft-edge-icon-128x128.png" />
                </a>
            </div>
        </div>
    `
})
export class UnsupportedBrowserComponent {
    private readonly appConfig = inject(APP_CONFIG_TOKEN);

    protected brandDisplayName: string;

    public ngOnInit(): void {
        this.brandDisplayName = this.appConfig.brandDisplayName;
    }
}
